import React, { useEffect, useState } from "react";
import { FileDown, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";

// Rapport annuel PDF à la charte : tous les biens ou un seul, année au choix.
export const AnnualReportButton = () => {
  const [open, setOpen] = useState(false);
  const [props, setProps] = useState([]);
  const y = new Date().getFullYear();
  const [year, setYear] = useState(y);
  const [pid, setPid] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) api.get("/guides/status").then((r) => setProps(r.data.properties || [])).catch(() => {}); }, [open]);
  const dl = async () => {
    setBusy(true);
    try {
      const r = await api.get("/reports/annual", { params: { year, property_id: pid || undefined }, responseType: "blob" });
      const a = document.createElement("a"); a.href = URL.createObjectURL(r.data); a.download = `rapport-annuel-${year}.pdf`; a.click();
      setOpen(false);
    } catch { toast.error("Rapport indisponible"); } finally { setBusy(false); }
  };
  return (
    <>
      <button onClick={() => setOpen(true)} className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-brand-soft bg-white hover:bg-brand-softer text-sm font-medium text-brand-greenDeep" data-testid="annual-report-open">
        <FileDown className="w-4 h-4 text-brand-limeDark" /> Rapport annuel
      </button>
      {open && (
        <div className="fixed inset-0 z-[70] bg-brand-greenDeep/40 flex items-center justify-center p-4" data-testid="annual-report-modal">
          <div className="bg-white rounded-[10px] w-full max-w-sm p-6 space-y-4">
            <div className="flex justify-between items-start">
              <div><p className="font-display text-2xl text-brand-greenDeep">Rapport annuel</p><p className="text-xs text-brand-green/60">Loyers, dépenses, cash-flow et patrimoine net, sur une page.</p></div>
              <button onClick={() => setOpen(false)} className="text-brand-green/40" data-testid="annual-report-close"><X className="w-5 h-5" /></button>
            </div>
            <label className="block text-xs font-medium text-brand-green/70">Année
              <select className="input mt-1 block w-full" value={year} onChange={(e) => setYear(Number(e.target.value))} data-testid="annual-report-year">{[y, y - 1, y - 2, y - 3].map((v) => <option key={v}>{v}</option>)}</select>
            </label>
            <label className="block text-xs font-medium text-brand-green/70">Périmètre
              <select className="input mt-1 block w-full" value={pid} onChange={(e) => setPid(e.target.value)} data-testid="annual-report-property">
                <option value="">Tous mes biens</option>{props.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
              </select>
            </label>
            <button onClick={dl} disabled={busy} className="w-full inline-flex items-center justify-center gap-2 px-4 py-3 rounded-full bg-brand-lime text-brand-greenDeep font-semibold text-sm" data-testid="annual-report-download">{busy && <Loader2 className="w-4 h-4 animate-spin" />} Télécharger le PDF</button>
          </div>
        </div>
      )}
    </>
  );
};
